import { render, staticRenderFns } from "./cashierDetail.vue?vue&type=template&id=196caf87&scoped=true&"
import script from "./cashierDetail.vue?vue&type=script&lang=js&"
export * from "./cashierDetail.vue?vue&type=script&lang=js&"
import style0 from "./cashierDetail.vue?vue&type=style&index=0&id=196caf87&prod&lang=scss&"
import style1 from "./cashierDetail.vue?vue&type=style&index=1&id=196caf87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196caf87",
  null
  
)

export default component.exports